<template>
  <div class="pageStyle" id="applyCenterDataList">
    <div class="header">
      <div class="search">
        <van-search
          v-model="query.companyNameLike"
          shape="round"
          show-action
          placeholder="请输入企业名称"
        >
          <template #action>
            <div class="searchBtn" @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="queryOptions">
        <div class="item">
          <div class="left">
            <div
              :class="queryValue1 == item.value ? 'choice' : 'noChoice'"
              v-for="(item, index) in queryOption1"
              :key="index"
              @click="choiceOptions(item.value)"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
          <div class="right" @click="showMoreOptionFlag = !showMoreOptionFlag">
            <div v-if="!showMoreOptionFlag">
              <span>更多条件</span><van-icon name="arrow-down" size="3.6vw" />
            </div>
            <div v-else>
              <span>收起</span><van-icon name="arrow-up" size="3.6vw" />
            </div>
          </div>
        </div>
        <div class="item" v-show="showMoreOptionFlag">
          <div
            v-for="(item, index) in queryOption2"
            :key="index"
            :class="item.showCloseFlag ? 'choice' : 'noChoice'"
          >
            <span @click="choiceOptions2(item.value)">{{ item.label }}</span>
            <van-icon
              @click="choiceOptions2(item.value)"
              v-show="!item.showCloseFlag"
              name="arrow-down"
              size="3.6vw"
            />
            <van-icon
              v-show="item.showCloseFlag"
              name="clear"
              size="3.6vw"
              @click="options2ToClose(index)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="dataList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in dataList" :key="index">
            <div class="title">
              <div class="left">
                <div><span></span></div>
                <!-- 企业名称 -->
                <div v-show="item.companyName">{{ item.companyName }}</div>
              </div>
              <!-- 申请状态 -->
              <div class="right">
                {{ applyStatus[item.status] }}
              </div>
            </div>
            <div class="msg">
              <div v-show="item.productId">
                <span>产品名称：</span
                ><span>{{
                  productNames[item.productId]
                    ? productNames[item.productId]
                    : item.productId
                }}</span>
              </div>
              <div>
                <span>申请人：</span><span>{{ item.names }}</span>
              </div>
              <div>
                <span>批款额度：</span><span>{{ item.creditLine }}</span>
              </div>
              <div>
                <span>借款额度：</span><span>{{ item.loanAmt }}</span>
              </div>
              <div v-show="item.rejectReason">
                <span>拒绝原因：</span><span>{{ item.rejectReason }}</span>
              </div>
              <div>
                <span>创建时间：</span
                ><span>{{ parseTime(item.createDateTime) }}</span>
              </div>
              <div>
                <span>更新时间：</span
                ><span>{{ parseTime(item.updateDateTime) }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!-- 快捷选项：订单日期 -->
    <van-calendar
      class="choiceDatePopupShow"
      v-model="choiceDatePopupShow"
      @confirm="choiceDateOnConfirm"
      :default-date="null"
      :min-date="new Date(2025, 0, 1)"
      title="选择订单创建时间"
      allow-same-day
      type="range"
      color="#4988fd"
    />
    <!-- 快捷选项：产品 -->
    <van-popup
      v-model="choiceProductPopupShow"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="popupDiv">
        <!-- <div class="title">选择产品</div> -->
        <div class="popupDiv-content">
          <van-picker
            title="选择产品"
            value-key="productName"
            show-toolbar
            :columns="productList"
            @confirm="productListPopupOnConfirm"
            @cancel="choiceProductPopupShow = !choiceProductPopupShow"
          />
        </div>
      </div>
    </van-popup>
    <!-- 快捷选项：订单状态 -->
    <van-popup v-model="choiceStatusPopupShow" position="bottom" round>
      <div class="popupDiv">
        <!-- <div class="title">选择产品</div> -->
        <div class="popupDiv-content">
          <van-picker
            title="选择订单状态"
            value-key="label"
            show-toolbar
            :columns="applyStatusForArr"
            @confirm="applyStatusPopupOnConfirm"
            @cancel="choiceStatusPopupShow = !choiceStatusPopupShow"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { parseTime } from "@/utils/index.js";
import { Icon, Toast, Search, List, Calendar, Popup, Picker } from "vant";
import { xcApplyByChannelId } from "@/api/applyCenter.js";
import { xcProductDict } from "@/api/product.js";
import { getCus as cusGetDict } from "@/api/dictDetail.js";
Vue.use(Icon);
Vue.use(Search);
Vue.use(List);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Calendar);
export default {
  data() {
    return {
      // 第一行快捷选项
      queryOption1: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "adopt",
          label: "已通过",
        },
        {
          value: "grant",
          label: "已放款",
        },
      ],
      // 第二行快捷选项
      queryOption2: [
        {
          value: "choiceDatePopupShow",
          label: "订单时间",
          showCloseFlag: false,
        },
        {
          value: "choiceProductPopupShow",
          label: "选择产品",
          showCloseFlag: false,
        },
        {
          value: "choiceStatusPopupShow",
          label: "订单状态",
          showCloseFlag: false,
        },
      ],
      queryValue1: "",
      queryValue2: "",
      dataList: [],
      showMoreOptionFlag: false,
      applyStatus: {},
      applyStatusForArr: [],
      query: {
        size: 10,
        page: 0,
        sort: "createDateTime,desc",
        createDateTimes: [],
      },
      loading: false,
      finished: false,
      // 快捷选项：订单状态
      choiceStatusPopupShow: false,
      // 快捷选项：产品
      choiceProductPopupShow: false,
      // 快捷选项：订单日期
      choiceDatePopupShow: false,
      // 产品名称信息
      productList: [],
      productNames: {},
    };
  },
  computed: {},
  mounted() {},
  created() {
    // 获取订单状态字典
    this.getProductStatus();
    // 获取产品名称信息
    this.getProductList();
  },

  methods: {
    parseTime,
    onSearch() {
      this.query.page = 0;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.getApplyData();
    },
    // 获取产品类型
    getProductStatus() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict("apply_status")
        .then((res) => {
          Toast.clear();
          this.applyStatusForArr = res;
          res.forEach((item) => {
            this.$set(this.applyStatus, item.value, item.label);
          });
          console.log("this.applyStatus", this.applyStatus);
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 获取产品列表
    getProductList() {
      xcProductDict()
        .then((res) => {
          console.log("Res", res);
          this.productList = res;
          res.forEach((item) => {
            this.$set(this.productNames, item.id, item.productName);
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 获取订单数据
    getApplyData() {
      if (!this.query.status) delete this.query.status;
      if (!this.query.productId) delete this.query.productId;
      if (!this.query.companyNameLike) delete this.query.companyNameLike;
      xcApplyByChannelId(this.query)
        .then((res) => {
          this.dataList = this.dataList.concat(res.content);
          this.loading = false;
          this.query.page++;
          if (res.content.length == 0) {
            this.finished = true;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 快捷选择1
    choiceOptions(value) {
      // 判断是否重复点击
      if (this.queryValue1 != value) {
        this.queryValue1 = value;
        this.query.status = value;
        this.scrollToDiv("applyCenterDataList");
        this.onSearch();
        // 清空第二行快捷选项的状态内容
        this.options2ToClose(2);
      }
    },
    // 快捷选项2
    choiceOptions2(popName) {
      this[popName] = true;
    },
    scrollToDiv(divId) {
      let div = document.getElementById(divId);
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    onLoad() {
      this.loading = true;
      this.getApplyData();
    },
    // 第二行快捷选项 清空按钮
    options2ToClose(index) {
      console.log("index", index);
      this.queryOption2[index].showCloseFlag = false;

      // 订单时间
      if (index == 0) {
        this.query.createDateTimes = [];
        this.queryOption2[index].label = "订单时间";
      }
      // 选择产品
      if (index == 1) {
        this.query.productId = "";
        this.queryOption2[index].label = "选择产品";
      }
      // 选择产品
      if (index == 2) {
        this.query.status = "";
        this.queryOption2[index].label = "订单状态";
      }
    },
    // 日历选择器 确认
    choiceDateOnConfirm(e) {
      this.query.createDateTimes[0] = this.convertToUTCAndFormat(e[0]);
      this.query.createDateTimes[1] = this.convertToUTCAndFormat(e[1]);
      this.queryOption2[0].label =
        this.utcToDate(e[0]) + " 至 " + this.utcToDate(e[1]);
      this.choiceDatePopupShow = false;
      this.queryOption2[0].showCloseFlag = true;
    },
    // 产品选择器 确认
    productListPopupOnConfirm(e) {
      this.query.productId = e.id;
      this.queryOption2[1].label = e.productName;
      this.queryOption2[1].showCloseFlag = true;
      this.choiceProductPopupShow = false;
    },
    // 订单状态选择器 确认
    applyStatusPopupOnConfirm(e) {
      this.query.status = e.value;
      this.queryValue1 = e.value;
      this.queryOption2[2].label = e.label;
      this.queryOption2[2].showCloseFlag = true;
      this.choiceStatusPopupShow = false;
    },
    convertToUTCAndFormat(dateStr) {
      const date = new Date(dateStr); // 假设dateStr是符合中国标准时间格式的字符串
      // 将Date对象转换为ISO字符串
      return date.toISOString();
    },
    utcToDate(utcDate) {
      const date = new Date(utcDate);
      const year = date.getUTCFullYear();
      const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // 月份是从0开始的
      const day = date.getUTCDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/applyCenter/index.vue